import React from "react";
import ProgrammingSearchEngine from "../../components/ProgrammingSearchEngine";

/* =================== WorkoutLibrary ==================== */
const WorkoutLibrary: React.FC = () => {
  return (
    <div className="flex-1 w-full">
      <div className="flex flex-col gap-8 mx-auto px-2 md:px-6 py-2 md:py-3">
        <ProgrammingSearchEngine searchSubscriptions />
      </div>
    </div>
  );
};

export default WorkoutLibrary;
